export const PRE_CART_TOTAL = 'PRE_CART_TOTAL'
export const PRE_CART_ITENS = 'PRE_CART_ITENS'
export const CART = 'CART'
export const DELETE_CART = 'DELETE_CART'
export const DELETE_PRE_CART_TOTAL = 'DELETE_PRE_CART_TOTAL'
export const DELETE_CART_ITENS = 'DELETE_CART_ITENS'